import { createProfessionalExporter } from '../../../utils/professionalExport';
import { getGymMemberId } from './memberData';

const headers = ['Serial No', 'Name', 'Phone', 'Email', 'Package', 'Trainer', 'Branch', 'Joining Date', 'Status'];

function formatStatus(status) {
  return status.charAt(0).toUpperCase() + status.slice(1);
}

const exporter = createProfessionalExporter({
  title: 'Member List',
  headers,
  slug: 'members',
  getRows: (memberList) =>
    memberList.map((member) => [
      getGymMemberId(member) || '—',
      member.name,
      member.phone,
      member.email,
      member.package,
      member.trainer,
      member.branch || '—',
      member.joiningDate,
      formatStatus(member.status),
    ]),
  getSummary: (memberList) => [
    `Total members: ${memberList.length}`,
    `Active: ${memberList.filter((m) => m.status === 'active').length}`,
  ],
});

export const printMemberList = (data) => exporter.print(data);
export const exportMemberCsv = (data) => exporter.csv(data);
export const exportMemberExcel = (data) => exporter.excel(data);
export const exportMemberPdf = (data) => exporter.pdf(data);
export const exportMembers = (data) => exporter.export(data);
